  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-row no-gutters>
      <v-col >

      <div class="container">
    <LineChart
      v-if="loaded"
      :chartdata="chartdata"
      :options="options"/>
  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>

import LineChart from '../../../components/Bar.vue'
export default {
  name: 'BarChartContainer',
  components: { LineChart },
  data: () => ({
    loaded: false,
    chartdata: {
      labels: ['January', 'February', 'Marco', 'Abril', 'Maio', 'Junho', 'Agosto', 'Setembro', 'Outbro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          label: 'Data One',
          backgroundColor: ['#f87979', 'blue', 'green', '#f87979', 'yellou', '#f87979', 'black', '#f87979', '#f87979', 'blank', '#f87979', '#f87979'],
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    },

    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
    //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
